// eslint-disable-next-line max-classes-per-file
import lcrRequest from '../lcrRequest';
import normalizeMatchMarkets from './utils';

export class MatchMarketsAPI {
  constructor(path, options) {
    const specifier = options.specifier === true
      ? '&specifier=live'
      : options.specifier === false
        ? '&specifier=prematch'
        : '';

    this.url = `${path}&alias=${options.alias}&lang=${options.language}${specifier}`;
    this.matchId = options.matchId;
  }

  get() {
    return lcrRequest
      .get(this.url)
      .then(data => {
        if (!data || (data && data.error)) {
          throw data;
        }
        return normalizeMatchMarkets(data, this.matchId);
      }).catch(e => {
        throw new Error(`Betstop API Request error: ${e}`);
      });
  }
}

export class MatchMarketsConfigRequest extends MatchMarketsAPI {
  constructor(matchId, specifier, alias, language) {
    super(`/api/allowed-odds-markets?match_id=${matchId}`, {
      matchId, specifier, alias, language,
    });
  }
}
